import React from 'react';
import { ChartHeader } from '../ChartHeader';
import * as ChartUI from '../ChartUI';
import { useChartContext } from '../ChartContext';
import ErrorChartInfo from '../ErrorChartInfo';
import { ChartViewType } from '../types';

const ChartFallback = () => {
  const {
    metadata: { mode },
  } = useChartContext();

  return (
    <ChartUI.Container>
      <ChartHeader />
      <ChartUI.ChartMainWrapper $mode={mode}>
        <ErrorChartInfo type={ChartViewType.FallbackError} />
      </ChartUI.ChartMainWrapper>
    </ChartUI.Container>
  );
};

export default ChartFallback;
